module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Resizer', {
    style: (_vm.elementCss),
    attrs: {
      "id": _vm.rptElementId,
      "index": _vm.index,
      "elmData": _vm.elmData,
      "maxPos": _vm.maxPos
    }
  }, [_c('ReportMenu', {
    attrs: {
      "slot": "menu",
      "elmData": _vm.elmData,
      "index": _vm.index
    },
    on: {
      "removeClicked": function($event) {
        return _vm.$emit('removeClicked', _vm.index)
      }
    },
    slot: "menu"
  }), _vm._v(" "), _c('span', {
    staticClass: "noselect",
    staticStyle: {
      "padding-right": "10px"
    },
    attrs: {
      "slot": "elmDText"
    },
    slot: "elmDText"
  }, [_vm._v(_vm._s(_vm.elmData.text))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c32596d4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ReportDesign/ReportElement.vue
// module id = 749
// module chunks = 0